<template>
  <FormulateInput
    type="toggle"
    v-model="_value"
    v-bind="$attrs"
    :label="label"
    :validation="validation"
    :labels="{
      checked: onLabel,
      unchecked: offLabel
    }"
    :disabled="disabled"
    :font-size="14"
    :sync="true"
    :height="30"
    :width="width"
  />
</template>

<script>
export default {
  props: {
    /**
     * Default toggle value
     * @model
     */
    value: {
      type: Boolean,
      default: false
    },
    /**
     * Default label when toggle is octive / checked.
     */
    onLabel: {
      type: String,
      default: 'On'
    },
    /**
     * Default label when toggle is not octive / unchecked.
     */
    offLabel: {
      type: String,
      default: 'Off'
    },
    /**
     * Width of the toggle in pixels.
     */
    width: {
      type: Number,
      default: 60
    },
    /**
     * Label that will be visible above the toggle button.
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * Disable the buttton
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Validation rules.
     */
    validation: {
      type: String
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style></style>
